import type { AddedProtectionSection } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { ResolvedAddedProtectionItem } from "./addedProtectionItemsResolver";
import addedProtectionItemsResolver from "./addedProtectionItemsResolver";

export interface ResolvedAddedProtectionSection {
    codename: string;
    items: ResolvedAddedProtectionItem[];
    sectionTitle: string;
    type: ContentTypeCodenames.AddedProtectionSection;
}

const addedProtectionSectionResolver = (
    data: AddedProtectionSection
): ResolvedAddedProtectionSection => {
    const { sectionTitle, items } = data.elements;
    const codename = data.system.codename;

    return {
        codename,
        items: addedProtectionItemsResolver(items.linkedItems),
        sectionTitle: sectionTitle.value,
        type: ContentTypeCodenames.AddedProtectionSection,
    };
};

export default addedProtectionSectionResolver;
